import React from 'react';
import styled from 'styled-components';
import { Divider, Grid } from '@mui/material';
import { LabelValue } from '../../../../../components';
import { PAGE_TEXT } from '../../../../Application/components/ApplicationForm/lang';

export const HKPFS: React.FunctionComponent<{
  HKPFSReferenceNumber: string;
}> = props => {
  const { HKPFSReferenceNumber } = props;

  const renderData = [
    {
      label: PAGE_TEXT.FELLOWSHIP.HKPFS.HKPFS_REFERENCE_NUMBER,
      value: HKPFSReferenceNumber,
      isFullWidth: true,
    },
  ];

  return (
    <Container>
      <Grid container spacing={2} padding={1}>
        {renderData.map((item, index) => {
          return (
            <Grid key={index} size={item.isFullWidth ? 12 : 6}>
              <LabelValue label={item.label} value={item.value} />
              <Divider />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

const Container = styled.div`
  .supporting-documents {
    padding: 0.5rem 0 0 2rem;

    .document-display {
      padding: 0.5rem 1rem;
    }
  }

  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 2rem;
  width: 100%;

  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-item {
    padding-left: 0 !important;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 2rem !important;
  }
`;
